import socialHeadlines from './8A-socialHeadlines.js';
import socialPictures from './8B-socialPictures.js';

export default async function socialSection() {
  const [haseHeadline, hasPictures] = await Promise.all([socialHeadlines(), socialPictures()]);

  if (!haseHeadline && !hasPictures) {
    $('.social-section').remove();
  }
}
